export enum TournamentsQueryKeys {
  Primary = '/tournaments',
  BySlug = '/tournaments/by-slug',
}
